module.exports = __webpack_public_path__ + "img/apartment_dialog_icon03.147be935.png";